import React from 'react';
import PropTypes from 'prop-types';

import { Criterium, CriteriumSkeleton } from '@hydra/common/criterium';
import { Translate } from '@hydra/common/components';
import { useReviewContext } from '@hydra/common/context';

import { getHostname } from '@hydra/utils/urlUtil';

const getContent = ({ tags, error, url }) => {
  if (error) {
    return <Translate content={error.toLowerCase()} with={{ url }} />;
  }
  const policyTag = tags.find(({ tag }) => tag === 'p');
  if (!policyTag) {
    return <Translate content='dmarc_record_policy_missing' with={{ url }} />;
  }
  if (policyTag && policyTag.value === 'none') {
    return <Translate content='dmarc_record_policy_none' with={{ url }} />;
  }

  return <Translate content='dmarc_record_valid' with={{ url }} />;
};

export const Dmarc = ({ criterium }) => {
  const { variant } = useReviewContext();
  const url = getHostname(criterium.url);
  return <Criterium criterium={criterium}>{variant === 'nocrit' ? <CriteriumSkeleton width='75%' /> : getContent({ ...criterium.data, url })}</Criterium>;
};

Dmarc.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      tags: PropTypes.array,
      error: PropTypes.string
    })
  })
};

export default React.memo(Dmarc);
